export default function Section({ children, className = "", style = {} }) {
  return (
    <section className={`mb-3 p-3 ${className}`} style={style}>
      {children}
    </section>
  );
}
